// IMPORT PACKAGE REFERENCES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// IMPORT PROJECT REFERENCES

import { fetchDevice } from '../State/Actions/DeviceActions';
import { DeviceSections } from '../DeviceBrowser/DeviceSections';
import { LoadingIndicator } from '../Shared/LoadingIndicator/LoadingIndicator';
import { Error } from '../Shared/Error/Error';

import { DeviceRowType } from '../DeviceBrowser/DeviceRowType';
import { DeviceRow } from '../DeviceBrowser/DeviceRow';
import { DeviceSection } from '../DeviceBrowser/DeviceSection';

// COMPONENT

export class DeviceStatusInformation extends Component {

    constructor(props) {
        super(props);
    }

    generateSections(device) {
        // We have to manually define how the sections are laid out.
        
        // 1. Device Info and Events.
        let rows = {};
        let sections = {};
        let row;

        if (device.hasOwnProperty("DeviceDetails")) {
            if (device.DeviceDetails.hasOwnProperty("dynamicDevice")) {
                let detail = device.DeviceDetails.dynamicDevice;
    
                row = new DeviceRow("Battery Level", DeviceRowType.BASIC, Math.round(detail.batteryLevel * 100) + "%");
                rows[row.uid] = row;

                row = new DeviceRow("Is Online?", DeviceRowType.BASIC, detail.isOnline === undefined ? "Unknown" : (detail.isOnline ? "Yes" : "No"));
                rows[row.uid] = row;

                row = new DeviceRow("Device Name", DeviceRowType.BASIC, detail.name);
                rows[row.uid] = row;

                row = new DeviceRow("Network Status", DeviceRowType.BASIC, detail.networkStatus);
                rows[row.uid] = row;

                row = new DeviceRow("Orientation", DeviceRowType.BASIC, detail.orientation);
                rows[row.uid] = row;

                row = new DeviceRow("Power State", DeviceRowType.BASIC, detail.powerState);
                rows[row.uid] = row;

                row = new DeviceRow("System Name", DeviceRowType.BASIC, detail.systemName);
                rows[row.uid] = row;

                row = new DeviceRow("System Version", DeviceRowType.BASIC, detail.systemVersion);
                rows[row.uid] = row;
            }
    
            if (device.DeviceDetails.hasOwnProperty("staticDevice")) {
                let staticDetails = device.DeviceDetails.staticDevice;
    
                row = new DeviceRow("Device Model", DeviceRowType.BASIC, staticDetails.model);
                rows[row.uid] = row;

                row = new DeviceRow("Screen Scale", DeviceRowType.BASIC, staticDetails.scale);
                rows[row.uid] = row;

                row = new DeviceRow("Screen Height", DeviceRowType.BASIC, staticDetails.height);
                rows[row.uid] = row;

                row = new DeviceRow("Screen Width", DeviceRowType.BASIC, staticDetails.width);
                rows[row.uid] = row;
            }
        }
        
        if (Object.keys(rows).length === 0) {
            row = new DeviceRow("No details.", DeviceRowType.EMPTY, '');
            rows[row.uid] = row;
        }

        let section = new DeviceSection("Device Details", rows);
        sections[section.uid] = section;

        return sections;
    }

    render() {
        return (
            <div>
                <DeviceSections sections={this.generateSections(this.props.device)} />
            </div>
        );
    }
}

